import React, { Component } from 'react';
import { RadioBinary, RadioBinaryHeader } from '../../components/RadioBinary';
import { RadioMultiButton } from "../../components/RadioMultiButton";
import { TextInput, SelectInput } from '../../components/BasicForm';
import { PrimaryFormNav } from '../../components/PrimaryFormNav';
import SelectFieldOptions from '../../utils/selectFieldOptions';

class VisitorQuestionnaire extends Component {
	state = {
		heading: 'Visitor Questionnaire',
		showProgressBar: true,
		pageId: 'visitor-questionnaire',
		scrollingToErr: false,
	}
	componentWillMount() {
		const stepData = this.props.stepData;
		if(!stepData.access) {
			this.props.previousStep(stepData);
		}
		this.props.setHeaderDisplay(
			this.state.heading,
      		stepData.displayStep,
			this.state.showProgressBar,
			this.state.pageId,
      		stepData.step
		);
	}
	componentDidMount() {
		document.getElementById('root').scrollIntoView();
		window.scrollBy(0, -10);
	}
	handlePrevious = () => {
		const stepData = this.props.stepData;
		this.props.previousStep(stepData);
	}
	handleSubmit = (fields) => {
		const isErr = this.props.validateStep(fields);  
	    const stepData = this.props.stepData;
	    const conditionalVal = this.props.fields.VADOCEmployee.value;
		conditionalVal === "no" ?
			stepData.altForward = true :
			stepData.altForward = false;
	    if(!isErr) {
	    	this.props.nextStep(stepData);
	    } else {
		    this.scrollToError()
	    }
	}
	scrollToError = () => {
		const fields = this.props.fields;
		let errFields = [];
		Object.keys(fields).map((fieldName) => {
			if(fields[fieldName].className === "input-err") {
				errFields.push(fieldName);
			}
			return fieldName;
		})
		const firstErr = document.querySelectorAll(`[name="${errFields[0]}"]`)[0];
		if (firstErr) {
			firstErr.scrollIntoView();
		}
	}
	render() {
		let fields = this.props.fields;
		const conditionalFields = this.props.conditionalFields;
		let activeParole;
		fields.activeParole.value === "yes" ? activeParole = true : activeParole = false
		fields = activeParole ? (
			{
				...fields, 
				VADOCId: conditionalFields.VADOCId, 
				ppDistrict: conditionalFields.ppDistrict
			}
		) : ( fields );
		return(	
			<form 
				className="visitation-form col-19"
				onSubmit={(e) => {this.handleSubmit(Object.keys(fields))}}>
				<RadioBinaryHeader
					posHeading="Yes"
					negHeading="No" />
				<RadioBinary
					legend={fields.VADOCEmployee.legend}
					name="VADOCEmployee"
					posId="y1"
					posVal="yes"
					negId="n1"
					negVal="no"
					className={fields.VADOCEmployee.className}
					errMessage={fields.VADOCEmployee.errMessage}
					checkedVal={fields.VADOCEmployee.value}
					handleBinaryChange={this.props.handleInputChange} />
				<RadioBinary
					legend={fields.activeParole.legend}
					name="activeParole"
					posId="y2"
					posVal="yes"
					negId="n2"
					negVal="no"
					className={fields.activeParole.className}
					errMessage={fields.activeParole.errMessage}
					checkedVal={fields.activeParole.value}
					handleBinaryChange={this.props.handleInputChange} />
				{activeParole ? (
					<div className="conditional-fields">
						<SelectInput
							options={SelectFieldOptions.pAndPDistrictOffices}
							id="ppDistrict"
							name="ppDistrict"
							className={fields.ppDistrict.className}
							label={fields.ppDistrict.label}
							value={fields.ppDistrict.value}
							required={fields.ppDistrict.isRequired}
							errMessage={fields.ppDistrict.errMessage}
							onChange={this.props.handleInputChange}  />
						<TextInput
							id="VADOCId"
							name="VADOCId"
							className={fields.VADOCId.className}
							label={fields.VADOCId.label}
							info={false}
							value={fields.VADOCId.value}
							required={fields.VADOCId.isRequired}
							errMessage={fields.VADOCId.errMessage}
							onChange={this.props.handleInputChange} />
					</div>
				) : (
					false
				)}
				<RadioBinary
					legend={fields.felonyConviction.legend}
					name="felonyConviction"
					posId="y3"
					posVal="yes"
					negId="n3"
					negVal="no"
					className={fields.felonyConviction.className}
					info={fields.felonyConviction.info}
					title={fields.felonyConviction.tipTitle}
					errMessage={fields.felonyConviction.errMessage}
					checkedVal={fields.felonyConviction.value}
					handleBinaryChange={this.props.handleInputChange} />
				<RadioBinary
					legend={fields.protectiveOrder.legend}
					name="protectiveOrder"
					posId="y4"
					posVal="yes"
					negId="n4"
					negVal="no"
					className={fields.protectiveOrder.className}
					errMessage={fields.protectiveOrder.errMessage}
					checkedVal={fields.protectiveOrder.value}
					handleBinaryChange={this.props.handleInputChange} />
				<RadioBinary
					legend={fields.gangAssociation.legend}
					name="gangAssociation"
					info={fields.gangAssociation.info}
					title={fields.gangAssociation.tipTitle}
					posId="y5"
					posVal="yes"
					negId="n5"
					negVal="no"
					className={fields.gangAssociation.className}
					errMessage={fields.gangAssociation.errMessage}
					checkedVal={fields.gangAssociation.value}
					handleBinaryChange={this.props.handleInputChange} />
				<div className="visitation-header">
					<h2>Types of Visitation</h2>
					<p>Please select which type of visitation you are applying for.</p>
					<fieldset id="visitation-type" className="col-18">
						<RadioMultiButton
							legend={fields.applicantVisitationType.label}
							required={fields.applicantVisitationType.isRequired}
							fieldOpts={fields.applicantVisitationType.options}
							fieldName="applicantVisitationType"
							checkedVal={fields.applicantVisitationType.value}
							errMessage={fields.applicantVisitationType.errMessage}
							handleMultiChange={this.props.handleInputChange}
						/>
					</fieldset>
				</div>
				<PrimaryFormNav
					prevLabel="start over"
					nextLabel="next"	
					handleNext={this.handleSubmit}
					handlePrevious={this.handlePrevious}
					options={Object.keys(fields)} />
			</form>
		)
	}
}

export default VisitorQuestionnaire;



// WEBPACK FOOTER //
// ./src/pages/VisitorQuestionnaire/VisitorQuestionnaire.js